<template>
  <div class="custom__toolbar d-flex mb-5">
    <v-spacer />
    <create></create>
  </div>
</template>

<script>
import Create from "./Create.vue";
export default {
  components: { Create }
};
</script>

<style lang="scss">
.session-toolbar {
  .v-toolbar__content {
    padding: 0px !important;
  }
}
</style>
